import React from "react";

import TeamMemberList from "@wc/domain/team-membership/components/team-member-list";

/**
 * @returns {React.ReactElement} The team members page
 */
export default function TeamMembers() {
  return <TeamMemberList readOnly={false} />;
}
